import 'slick-carousel';
import NumberHelper from "../../Shared/Helpers/numberHelper";
import HtmlElementHelper from "../../Shared/Helpers/htmlElementHelper";

document.addEventListener('DOMContentLoaded', function () {
    let rechargeBtn: boolean = true;

    const phoneInput = document.getElementById("fonmoney-number") as HTMLInputElement;
    const emailInput = document.getElementById("fonmoney-email") as HTMLInputElement;

    let fonmoneyNumberInput: HTMLInputElement;

    if (phoneInput != null)
    {
         fonmoneyNumberInput = phoneInput;
    }
    else
    {
        fonmoneyNumberInput = emailInput;
    }
        

    if (!!fonmoneyNumberInput?.value) {
        setTimeout(function () {
            document.getElementById("recharge")?.click();
        }, 1);
    }

    window.addEventListener("orientationchange", function () {
        window.location.reload();
    });

    fonmoneyNumberInput.focus();

    const topup = (<any>window).topup;
    const prefix = (topup && topup.countryPrefix) || "";
    fonmoneyNumberInput.addEventListener("keypress", function (e: KeyboardEvent) {
        if (e.key === "Enter") {
            e.preventDefault(); // Prevent form submission
            document.getElementById("recharge")?.click();
        }

        // Allow only numeric input
        if (e.key !== "Backspace" && e.key !== "Delete" && (e.key < "0" || e.key > "9")) {
            e.preventDefault(); // Prevent non-numeric input
        }
    });

    fonmoneyNumberInput.addEventListener("input", function () {
        setTimeout(function () {
            if (fonmoneyNumberInput.value.startsWith(prefix)) {
                let newNum = fonmoneyNumberInput.value || "";
                if (newNum.length > prefix.length) {
                    newNum = newNum.substring(prefix.length);
                }
                fonmoneyNumberInput.value = newNum.trim().replace(/[^\d.]/g, "");
            }
            // Do something with text
        }, 50);
    });

    const validatePhoneEl = document.querySelectorAll('.validate-phone-fonmoney');

    validatePhoneEl.forEach(function (input) {
        input.addEventListener('focusout', function (e) {
            const targetElement = e.target as HTMLInputElement;
            const regex = targetElement.getAttribute("validator");
            const re = new RegExp(regex);
            const isValid = re.test(targetElement.value);
            const btn = document.getElementById("recharge") as HTMLButtonElement;

            if (!isValid) {
                HtmlElementHelper.Show(".notbe-checked");
                if(btn) {
                    btn.disabled = true;
                    btn.style.backgroundColor = "rgb(204, 204, 204)";
                }
            } else {
                HtmlElementHelper.Hide(".notbe-checked");
                if(btn) {
                    btn.disabled = false;
                    btn.style.backgroundColor = "#009eda";
                }
            }
        });

        input.addEventListener('keypress', function (e: KeyboardEvent) {
            if (e.key === 'Enter') {
                return;
            }
            const targetElement = e.target as HTMLInputElement;
            const regex = targetElement.getAttribute("validator");
            const re = new RegExp(regex);
            const isValid = re.test(targetElement.value);
            const btn = document.getElementById("recharge");

            if (!isValid) {
                btn?.setAttribute("disabled", "disabled");
                if (btn) {
                    btn.style.backgroundColor = "rgb(204, 204, 204)";
                }
            } else {
                btn?.removeAttribute("disabled");
                if (btn) {
                    btn.style.backgroundColor = "#009eda";
                }
            }

            rechargeBtn = true;
            HtmlElementHelper.Hide(".warning-blue");
            let checkNumberBtn = document.querySelectorAll('.number-check-btn');
            checkNumberBtn.forEach(function (btn: HTMLElement) {
                btn.style.backgroundColor = '#009eda';
            });
            HtmlElementHelper.Hide(".pc-btn-5");
            (document.querySelector('#new-top-up-prices .pc-price-5 .price-body') as HTMLElement).style.paddingBottom = "20px";

            // Change color of recharge btn
            if (window.innerWidth <= 320) {
                checkNumberBtn.forEach(function (btn: HTMLElement) {
                    HtmlElementHelper.ShowEl(btn)
                });
            }
        });
    });

    //show or hide the please enter number msg
    function handleClick() {
        document.getElementById("fonmoney-number").focus();
        HtmlElementHelper.Hide(".warning");
    }

    document.querySelectorAll('.new-topup .number-check-prefix')
        .forEach(function (prefix) {
            prefix.addEventListener('click', handleClick);
        });

    document.querySelectorAll('.new-topup .flags')
        .forEach(function (flag) {
            flag.addEventListener('click', handleClick);
        });

    //show or hide the please enter number msg
    const numberCheck = document.querySelector('.number-check') as HTMLInputElement;
    numberCheck.addEventListener('click', () => {
        HtmlElementHelper.Hide('.warning')
    });

    document.querySelectorAll("#new-top-up-prices .item-col").forEach(itemCol => {
        itemCol.addEventListener('click', () => {
            const number = numberCheck.value;
            HtmlElementHelper.Hide('.warning')

            if (number !== "") {
                const numberCheckBtn = document.querySelector('.number-check-btn') as HTMLElement;
                numberCheckBtn.click();
            } else {
                HtmlElementHelper.Show('.enter-number-message');
            }
        });
    });

    //refresh the selection in the columns
    function refreshSelection() {
        if (rechargeBtn !== false)
            return;
        const itemCols = document.querySelectorAll("#new-top-up-prices .item-col");
        itemCols.forEach(itemCol => {
            itemCol.addEventListener('mouseover', () => {
                const activeElements = document.querySelectorAll('.active');
                activeElements.forEach(element => {
                    element.classList.remove('active');
                });
                itemCol.children[0].classList.add('active');
            });
        });
    }


    let rechargeStatus = false;

    function isMobile() {
        return (screen.width <= 414) && (screen.height <= 736);
    }

    function mobileFnc() {
        if (isMobile()) {
            const firstListItem = document.querySelector('.choosing li:first-child') as HTMLElement;

            if (firstListItem)
                firstListItem.click();
        }
    }

    function createSwipe() {

        ($(".itens-list") as any).slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            initialSlide: 0
        });

        function selectCurrentSlide(el: any) {
            el.removeClass('pc-btn-active-color ');
            el.find(".pc-btn").addClass('pc-btn-active-color ');
            el.removeClass('pricing-active-color');
            el.addClass('pricing-active-color');
            el.find(".price-body").addClass('pricing-active-color');
            el.removeClass('pricing-active-color');
            el.find(".price-head").addClass('pricing-active-color');
        }

        if (!rechargeBtn) {
            //initialize the first slider
            const currentSlide = document.querySelector('.slick-active')?.getAttribute('data-slick-index');
            const current = document.querySelector('.slick-slide[data-slick-index="' + currentSlide + '"]');
            selectCurrentSlide($(current));

            const prevNextButtons = document.querySelectorAll('.slick-prev, .slick-next');
            prevNextButtons.forEach(button => {
                button.addEventListener('click', () => {
                    const currentSlide = document.querySelector('.slick-active')?.getAttribute('data-slick-index');
                    const current = document.querySelector('.slick-slide[data-slick-index="' + currentSlide + '"]');
                    selectCurrentSlide(current);
                });
            });

        }

    }

    function removeSwipe() {
        ($(".itens-list") as any).slick('unslick');
    }

    if (isMobile()) {
        createSwipe();
    }

    mobileFnc();
    refreshSelection();

    // if the topup allowed for the country
    if (topup.isAllowed) {
        const topupForm = document.querySelector('#TopupForm') as HTMLFormElement;
        topupForm.addEventListener('submit', (e) => {
            e.preventDefault();

            // get values from inputs
            const email = (document.querySelector("input[name='NautaMail']") as HTMLInputElement)?.value;
            const number = (document.querySelector("#fonmoney-number") as HTMLInputElement)?.value;
            const country = (document.querySelector("input[name='CountryCode']") as HTMLInputElement)?.value;

            if (country === "TR") {
                if (number && number.charAt(0) === '0') {
                    const updatedNumber = number.substr(1);
                    (document.querySelector("#fonmoney-number") as HTMLInputElement).value = updatedNumber;
                    (document.querySelector("#number-check") as HTMLInputElement).value = updatedNumber;
                }
            }

            //hide warning message
            const warningElements = document.querySelectorAll('.warning');
            warningElements.forEach((warning: HTMLElement) => { warning.style.display = 'none'; });

            if (rechargeBtn && (!!number || !!email)) {
               //show the progress bar
                $(".progress").show();

                function getColsRefresh() {
                    const itemCols = document.querySelectorAll("#new-top-up-prices .item-col");

                    itemCols.forEach(itemCol => {
                        itemCol.addEventListener('mouseover', () => {
                            if (rechargeBtn === false && rechargeStatus === false) {
                                const priceBodyElements = document.querySelectorAll('.price-body');
                                const priceHeadElements = document.querySelectorAll('.price-head');

                                priceBodyElements.forEach(priceBody => {
                                    priceBody.classList.remove('pricing-active-color');
                                });

                                itemCol.classList.add('pricing-active-color');
                                itemCol.querySelector(".price-body")?.classList.add('pricing-active-color');

                                priceHeadElements.forEach(priceHead => {
                                    priceHead.classList.remove('pricing-active-color');
                                });

                                itemCol.querySelector(".price-head")?.classList.add('pricing-active-color');
                            }
                        });

                        itemCol.addEventListener('mouseleave', () => {
                            if (rechargeBtn === false && rechargeStatus === false) {
                                const pricingActiveElements = document.querySelectorAll('.pricing-active-color');

                                pricingActiveElements.forEach(pricingActive => {
                                    pricingActive.classList.remove('pricing-active-color');
                                });
                            }
                        });
                    });
                }

                //get cols
                getColsRefresh();

                const url = topup.checkPricesUrl as string;
                // start ajax to check and return the prices
                $.ajax({
                    url: url,
                    data: $("#TopupForm").serialize(),
                    type: "POST",
                    complete: () => {
                        //hide the progress field
                        HtmlElementHelper.Hide('.progress');
                    },
                    error: () => {
                        rechargeBtn = true;
                        HtmlElementHelper.Show('.notbe-checked');
                    },
                    success: function (data, status) {
                        if (data !== "false" && data !== "" && data.Content) {
                            HtmlElementHelper.Hide('.warning');
                            HtmlElementHelper.Show('.warning-blue');

                            //change text color
                            (document.querySelector('#new-top-up-prices .pc-price-5') as HTMLElement).style.color = '#6f6f6f';
                            // if mobile remove the recreate the swipe
                            if (isMobile()) {
                                removeSwipe();

                                //scroll to element
                                const htmlBody = document.querySelector('html, body');
                                const topupTitle = document.querySelector('.topup-title') as HTMLElement;
                                if (htmlBody && topupTitle) {
                                    htmlBody.scrollTo({
                                        top: topupTitle.offsetTop,
                                        behavior: 'smooth'
                                    });
                                }
                            }

                            getColsRefresh();

                            rechargeBtn = false;
                            //disable the recharge btn
                            document.getElementById('recharge').id = 'recharge-off';
                            //get the product list from json
                            const parser = new DOMParser();
                            const html = parser.parseFromString(data.Content, 'text/html');
                            const productListHtml = html.querySelector('#topupItemsHolder');
                            if (productListHtml) {
                                const topupItemsHolder = document.querySelector('#topupItemsHolder');
                                if (topupItemsHolder && topupItemsHolder.parentNode) {
                                    topupItemsHolder.parentNode.replaceChild(productListHtml, topupItemsHolder);
                                }
                                NumberHelper.formatDecimals(topupItemsHolder);
                            }

                            // Since the new HTML form is rendered after initial binding,
                            // when new form appears - we have to bind again the submit's.
                            // To avoid double binding, clean old ones before
                            const bindQuickRegModal = (<any>window).bindQuickRegModal;
                            if (bindQuickRegModal) {
                                let el = document.querySelector('form[data-quickreg="True"]');
                                el.removeEventListener("submit", bindQuickRegModal);
                                el.addEventListener("submit", bindQuickRegModal);
                            }

                            //get everything again
                            getColsRefresh();

                            // if mobile remove the recreate the swipe
                            if (isMobile()) {
                                if (window.innerWidth >= 320) {
                                    createSwipe();
                                }
                            }

                            //get everything again
                            getColsRefresh();

                            //change color of recharge btn
                            if (window.innerWidth > 320) {
                                (document.querySelector('.number-check-btn') as HTMLElement).style.backgroundColor = '#ccc';
                            } else {
                                HtmlElementHelper.Hide('.number-check-btn');
                            }


                            //show the continue btn
                            const liElements = document.querySelectorAll('#new-top-up-prices .price-body ul li');
                            liElements.forEach((li: HTMLElement) => {
                                li.style.paddingBottom = '0';
                            });

                            const priceBody = document.querySelectorAll('#new-top-up-prices .pc-price-5 .price-body');
                            priceBody.forEach((el: HTMLElement) => {
                                el.style.paddingBottom = '0';
                            })
                            HtmlElementHelper.Show('.recharge');

                            $("#new-top-up-prices .item-col").on("click", function () {
                                rechargeStatus = true;
                                getColsRefresh();
                                $(".warning-blue").hide();
                                const btn = $(this).find('.recharge');

                                const value = btn.attr('data-value');
                                const operator = btn.attr('data-operatorId')
                                $("#topup-value").val(value);
                                $("#topup-operatorId").val(operator);

                                //check if is logged or not
                                if ($('form#product_addtocart_form').attr('data-quickreg') == "true") {
                                    ($('.reg-holder') as any).iziModal('open');
                                } else {
                                    $('#product_addtocart_form').submit();
                                }
                            });

                            const itemCols = document.querySelectorAll("#new-top-up-prices .item-col");
                            itemCols.forEach(itemCol => {
                                itemCol.addEventListener('click', () => {
                                    rechargeStatus = true;
                                    getColsRefresh();
                                    HtmlElementHelper.Hide(".warning-blue");

                                    const btn = itemCol.querySelector('.recharge') as HTMLElement;
                                    const value = btn.getAttribute('data-value');
                                    const operator = btn.getAttribute('data-operatorId');

                                    const topupValue = document.querySelector("#topup-value") as HTMLInputElement;
                                    if (topupValue) {
                                        topupValue.value = value;
                                    }

                                    const topupOperatorId = document.querySelector("#topup-operatorId") as HTMLInputElement;
                                    if (topupOperatorId) {
                                        topupOperatorId.value = operator;
                                    }

                                    //check if is logged or not
                                    const productAddToCartForm = document.querySelector('form#product_addtocart_form');
                                    if (productAddToCartForm && productAddToCartForm.getAttribute('data-quickreg') === "true") {
                                        const regHolder = document.querySelector('.reg-holder');
                                        if (regHolder && typeof (regHolder as any).iziModal === 'function') {
                                            (regHolder as any).iziModal('open');
                                        }
                                    } else {
                                        const productAddToCartFormElement = document.querySelector('#product_addtocart_form') as HTMLFormElement;
                                        if (productAddToCartFormElement) {
                                            productAddToCartFormElement.submit();
                                        }
                                    }
                                });
                            });


                            const topupNumber = document.querySelector('#topup-number') as HTMLInputElement;
                            if (topupNumber) {
                                topupNumber.value = number;
                            }


                        } else {
                            HtmlElementHelper.Hide('.progress');
                            HtmlElementHelper.Show('.notbe-checked');
                        }
                    }
                });
            } else if (rechargeBtn) {
                HtmlElementHelper.Show('.enter-number-message');
            }
        });
    } //end isALlowed
});
